import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-erro-409',
  templateUrl: './modal-erro-409.component.html',
  styleUrls: ['./modal-erro-409.component.scss']
})
export class ModalErro409Component {
  tituloSingular = '';
  tituloPlural = '';
  
  itens: string[] = [];

  constructor(@Inject(NZ_MODAL_DATA) public data: { itens: string[] }) {
    this.itens = data.itens;
  }
}
